
import React from 'react';
import Grid from '@material-ui/core/Grid'
import Button from "@material-ui/core/Button";
import { db } from '../../firebase'
import firebase from 'firebase'

class MiniPostComponent extends React.Component {
    state = {
        input: '',
        nameName: '',
        confMessage: '',
        isError: false,
    };

    onChangeText = (e) => {
		this.setState({input: e.target.value})
	};

    addEntry = (evt) => {
        if (!this.state.input || !this.state.username){
            this.setState({isError: true, confMessage: 'Uhoh! Login Again!'});
            return;
        }

        db.collection('entries').add({
            text: this.state.input,
            username: this.state.username,
            timestamp: firebase.firestore.FieldValue.serverTimestamp()
        })

        this.setState({input: '', isError: false, confMessage: 'Posted to Journal!'});
        setTimeout(() => {
            this.hideConfMessage();
        }, 3000);
    }

    hideConfMessage = () => {
        this.setState({confMessage: ''});
    }

    componentDidMount = () => {
        if (firebase.auth().currentUser) {
            this.setState({username: firebase.auth().currentUser.uid})
        }
    }

    render = () => {
        return (
            <Grid xs={9} className="miniPost">
                <textarea onChange={((e) => this.onChangeText(e))} value={this.state.input} className="miniJournal" placeholder="Add your thoughts here!"></textarea>
                <div className={"confirmationBits " + (this.state.isError ? 'redConfirm' : 'greenConfirm')} >{ this.state.confMessage ? this.state.confMessage : ''}</div>
                <Button onClick={() => this.addEntry()}  className="miniButton">Add to Journal</Button>
            </Grid>
        )
    };
}

export default MiniPostComponent;
